import differenceInDays from "date-fns/differenceInDays";
import { startOfDay, endOfDay } from "date-fns";

interface Interval {
  start: Date;
  end: Date;
}

export default class ProjectTaskBar {
  public constructor(
    private readonly task: Interval,
    private readonly chart: Interval
  ) {}

  /**
   * 長さ
   */
  public get span(): number {
    if (this.isOutOfChart()) return 0;
    const days = differenceInDays(this.end, this.start);
    if (days < 0) return 0;
    return days + 1;
  }

  /**
   * 開始日
   */
  public get start(): Date {
    if (this.isOutOfChart()) throw new Error("out of chart");
    if (this.task.start < this.chart.start) return this.chart.start;
    return startOfDay(this.task.start);
  }

  /**
   * 終了日
   */
  public get end(): Date {
    if (this.isOutOfChart()) throw new Error("out of chart");
    if (this.chart.end < this.task.end) return this.chart.end;
    return endOfDay(this.task.end);
  }

  /**
   * チャートの左端との相対位置を取る
   */
  public get startIndex(): number {
    return differenceInDays(this.start, this.chart.start);
  }

  public isOutOfChart() {
    return this.task.end < this.chart.start || this.task.start > this.chart.end;
  }
}
